import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { BlockquoteNodeView } from "@/components/editor/nodeviews/BlockquoteNodeView";

/**
 * Blockquote block — variants per user direction (2026-05-14):
 *
 *   variant = "simple"     → \begin{quote}…\end{quote}      (core LaTeX)
 *   variant = "epigraph"   → \epigraph{text}{attribution}    (`epigraph` package)
 *   variant = "verse"      → \begin{verse}…\end{verse}      (core LaTeX, line breaks preserved)
 *
 * `text` carries the quotation body. `attribution` is read only when
 * variant is "epigraph" — ignored otherwise.
 */
export const BlockquoteBlock = Node.create({
  name: "blockquoteBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      text: { default: "" },
      variant: { default: "simple" },
      attribution: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="blockquote-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "blockquote-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(BlockquoteNodeView);
  },
});
